<div style="height: 100vh !important; width: 100vw; overflow: hidden;">
    <router-outlet></router-outlet>
</div>